// @flow
import * as React from 'react';
import {HashRouter as Router, Route} from 'react-router-dom';
import {ThemeProvider} from 'styled-components';
import ModalRotateDevice from 'components/ModalRotateDevice';
import Home from './home/Home';
import CountrySelection from './home/CountrySelection';
import Intro from './home/Intro';
import Tutorial from './home/Tutorial';
import Survey from './survey/SurveyRouter';
import DrivingZone from './driving-zone';
import {useLayoutState} from 'components/Layout';
import {ScrollToTop} from 'utils/hookUtils';
import styled from 'styled-components';
import { isMobileOnly as isMobile, isChrome, isIOS, isSafari } from 'react-device-detect';

export default function PageRouter(): React.Element<any> {
  const layoutState = useLayoutState();
  const theme = React.useMemo(() => {
    return {layout: layoutState};
  }, [layoutState]);
  const [openRotateDevice, setOpenRotateDevice] = React.useState(false);

  React.useEffect(() => {

    function checkPageTopAndReload() {
      if (isMobile && isSafari) {

      } else {
        return;
      }
      if (window.visualViewport != null) {
        if (window.visualViewport.pageTop > 0) {
          window.location.reload();
          // if (window.visualViewport.pageTop > 0) {
            
          // }

          // setTimeout(()=>{
          // }, 1000);
        }
      }

    }

    if (window.visualViewport != null) {
      window.visualViewport.addEventListener("scroll", checkPageTopAndReload);
    }
    const checkTimer = setInterval(checkPageTopAndReload, 1000);

    return ()=>{
      clearInterval(checkTimer);
    };
  }, []);

  React.useEffect(() => {

    if (isMobile && isChrome && isIOS) {
      if (window.firstLoadedPortrait_iOS_Chrome == null) {
        window.firstLoadedPortrait_iOS_Chrome = layoutState.mobile && layoutState.height > layoutState.width;
      }


      if (window.firstLoadedPortrait_iOS_Chrome && !(layoutState.mobile && layoutState.height > layoutState.width)) {
        setTimeout(function(){
          window.location.reload();
        }, 1000);
      }
    } else if (isMobile && isSafari) {

    }
    setOpenRotateDevice(layoutState.mobile && layoutState.height > layoutState.width);
  }, [layoutState.width, layoutState.height, layoutState.mobile]);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <ScrollToTop />
        <Route path="/" exact>
          <Home />
        </Route>
        <Route path="/country-selection">
          <CountrySelection nextPath="/intro" />
        </Route>
        <Route path="/intro">
          <Intro nextPath="/welcome" />
        </Route>
        <Route path="/welcome">
          <Tutorial nextPath="/survey" />
        </Route>
        <Route path="/survey">
          <Survey />
        </Route>
        <Route path="/driving-zone">
          <DrivingZone />
        </Route>
      </Router>
      <ModalRotateDevice open={openRotateDevice} onClose={() => setOpenRotateDevice(false)} />
      {isIOS && isChrome && isMobile && <FillBottomBlack />}
    </ThemeProvider>
  );
}



const FillBottomBlack = styled.div`
  position: absolute;
  bottom: -50px;
  left: 0px;
  right: 0px;
  width: auto;
  height: 50px;
  background-color: #000;
`;
